import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  prices: {},  
  initialPrices: {},  
  changes: {},  
  symbols: [],
  symbolIcons: {},
  symbolsInfo: {},
  finishedLoad: false,
  spinList: false,
  symbolList: [],
  selectedSymbol:'',
  selectedRowIndex:null
};

const streamCryptoInfoSlicer = createSlice({
  name: 'streamCryptoInfo',
  initialState,
  reducers: {
    setPrices: (state, action) => {
      state.prices = action.payload;
    },    
    setInitialPrices: (state, action) => {
      state.initialPrices = action.payload;
    },    
    setChanges: (state, action) => {
      state.changes = action.payload;
    },    
    setSymbols: (state, action) => {
      state.symbols = action.payload;
    },    
    setSymbolIcons: (state, action) => {
      state.symbolIcons = action.payload;
    },    
    setSymbolsInfo: (state, action) => {
      state.symbolsInfo = action.payload;
    },    
    setFinishLoad: (state, action) => {
      state.finishedLoad = action.payload;
    },    
    setSpinList: (state, action) => {
      state.spinList = action.payload;
    },    
    setSymbolList: (state, action) => {
      state.symbolList = action.payload;
    },    
    setSelectedSymbol: (state, action) => {
      state.selectedSymbol = action.payload;
    },    
    setSelectedRowIndex: (state, action) => {
      state.selectedRowIndex = action.payload;
    },    
  }  
});

export const { setPrices, setInitialPrices, setChanges, setSymbols, setSymbolIcons, setSymbolsInfo, setFinishLoad, setSpinList, setSymbolList, setSelectedSymbol, setSelectedRowIndex  } = streamCryptoInfoSlicer.actions;
export default streamCryptoInfoSlicer.reducer;